// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_18mlf","visuallyhidden":"_3TRWV","hide-text":"_1DUpp","center":"_1wDG7","noprint":"_1OR97","root":"_2lH8k"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-comments/styles/CoreComments.scss
 ** module id = 939
 ** module chunks = 1
 **/